import { useMemo, useState } from "react";
import { Link } from "wouter";
import { INDEX_MINT, INDEX_SYMBOL, shortMint } from "../lib/data";

export default function RewardsPage({ data }) {
  const [wallet, setWallet] = useState("");
  const basket = data?.basket?.entries || [];

  const preview = useMemo(() => {
    if (!wallet.trim()) return null;
    return {
      wallet: wallet.trim(),
      legs: basket.map((e) => ({
        symbol: e.symbol,
        weight: `${(Number(e.weight || 0) * 100).toFixed(1)}%`,
      })),
    };
  }, [wallet, basket]);

  return (
    <section className="app-section" style={{ paddingTop: "2.5rem" }}>
      <div className="shell">
        <p className="section-kicker">
          <i className="brand-diamond" aria-hidden /> Rewards
        </p>
        <h2 className="section-title">Your share of the basket</h2>
        <p className="section-lead" style={{ marginLeft: 0, textAlign: "left" }}>
          {`Claimed $${INDEX_SYMBOL} creator fees buy the active board and airdrop to holders. ATA rent is capped; burned ATAs are blacklisted and paid in SOL. For live balances, use `}
          <Link href="/portfolio">Portfolio</Link>.
        </p>

        <div className="two-col">
          <div className="panel">
            <h3>Lookup</h3>
            <p>
              Paste a wallet to preview how the current basket would weight a
              payout. Live balances plug into the worker on deploy.
            </p>
            <div className="field">
              <label htmlFor="wallet">Wallet</label>
              <input
                id="wallet"
                placeholder="Solana address"
                value={wallet}
                onChange={(e) => setWallet(e.target.value)}
                autoComplete="off"
                spellCheck={false}
              />
            </div>
            {preview && (
              <>
                <div className="stat-row">
                  <span>Wallet</span>
                  <strong className="mono">{shortMint(preview.wallet, 6)}</strong>
                </div>
                <div className="stat-row">
                  <span>Index</span>
                  <strong>{INDEX_SYMBOL}</strong>
                </div>
                {preview.legs.map((l) => (
                  <div className="stat-row" key={l.symbol}>
                    <span>{l.symbol}</span>
                    <strong>{l.weight}</strong>
                  </div>
                ))}
              </>
            )}
          </div>

          <div className="panel">
            <h3>Payout rules</h3>
            <div className="stat-row">
              <span>Source</span>
              <strong>{`$${INDEX_SYMBOL} creator fees`}</strong>
            </div>
            <div className="stat-row">
              <span>Fee model</span>
              <strong>standard · 2%</strong>
            </div>
            <div className="stat-row">
              <span>Cadence</span>
              <strong>every {(data?.schedule?.payoutIntervalMin || 10)}m UTC</strong>
            </div>
            <div className="stat-row">
              <span>Minimum</span>
              <strong>≥ {data?.schedule?.minDistributeSol ?? 0.02} SOL</strong>
            </div>
            <div className="stat-row">
              <span>ATA budget</span>
              <strong>≤ 40% of cycle</strong>
            </div>
            <div className="stat-row">
              <span>Closed ATA</span>
              <strong>blacklist → SOL</strong>
            </div>
            <div className="stat-row">
              <span>Mint</span>
              <strong className="mono">{shortMint(INDEX_MINT)}</strong>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
